import { canvasTextWidthFonted } from '../../../fun-js-lib/canvas'
import { getStyledFont } from './span'

/**
 * Represents word with styles
 */
export default class WordSpan {
  /**
   * @param {import('./span').Span} parentSpan 
   * @param {string} text 
   * @param {boolean} hasLeftSpace 
   * @param {boolean} hasRightSpace
   */
  constructor (parentSpan, text, hasLeftSpace, hasRightSpace) {
    this.isBold = parentSpan.isBold
    this.isItalic = parentSpan.isItalic
    this.isUnderlined = parentSpan.isUnderlined
    this.text = text
    this.hasLeftSpace = hasLeftSpace
    this.hasRightSpace = hasRightSpace
    this.parentSpan = parentSpan
  }

  /**
   * @param {CanvasRenderingContext2D} context
   */
  width (context) {
    const initFont = context.font;
    const font = getStyledFont(this.parentSpan, initFont);
    return canvasTextWidthFonted(context, this.text, font)
  }
}